import { uiModelToAsantoResiRequest } from './resi';

export function getAsantoMapperFunc(lendingType: 'btl' | 'resi') {
  switch (lendingType) {
    case 'resi':
      return uiModelToAsantoResiRequest;
    default:
      throw new Error(`Unknown lending type: '${lendingType}'.`);
  }
}
